/* eslint-disable class-methods-use-this */
import _ from 'lodash';
import * as api from '../../../../utils/apiClient';
import {
  restructureUserRatingStatusesModel,
  restructureRatingPointModel
} from './restructuring';
import { restructurePaginationModel } from '../../../../common/restructuring';

class UserRatingService {
  async getUserRatingStatuses(state) {
    // console.log(queryParams);
    const response = await api.get('/user-rating-statuses', {});
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    return {
      response: responseJson,
      destructData: {
        itemsById: _.keyBy(
          _.map(responseJson.data.items, item =>
            restructureUserRatingStatusesModel(state, item)
          ),
          'id'
        ),
        itemsIds: _.map(responseJson.data.items, item => item.id)
      }
    };
  }

  async getAuthUserRatingHistory(state, queryParams) {
    const response = await api.get('/user-rating-points/me', {
      expand: 'points_type',
      ...queryParams
    });
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    return {
      response: responseJson,
      destructData: {
        itemsById: _.keyBy(
          _.map(responseJson.data.items, item =>
            restructureRatingPointModel(state, item)
          ),
          'id'
        ),
        itemsIds: _.map(responseJson.data.items, item => item.id),
        pagination: restructurePaginationModel(
          _.get(responseJson, 'data._meta')
        )
      }
    };
  }
}

export default new UserRatingService();



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/userRating/services/UserRatingService/UserRatingService.js